import { z } from "zod";

export const themeSchema = z.enum([
	"florada",
	"orvalho",
	"torra",
	"cereja",
	"dourado",
]);

export const modeSchema = z.enum(["light", "dark"]);

export const themeConfigSchema = z.object({
	id: themeSchema,
	name: z.string(),
	color: z.string(),
});

export type Theme = z.infer<typeof themeSchema>;
export type Mode = z.infer<typeof modeSchema>;
export type ThemeConfig = z.infer<typeof themeConfigSchema>;
